import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styled, { useTheme } from 'styled-components';
//
import {
  FaSearch,
  FaUser,
  FaExchangeAlt,
  FaHeart,
  FaShoppingCart,
  FaBars,
} from 'react-icons/fa';
import { CiLogout } from 'react-icons/ci';
import { IoCloseOutline } from 'react-icons/io5';
//
import { BodyText, Input } from './ui';
import logo from '../assets/images/logo.png';
import { getCartList, removeCart } from '../api/services/cartService';
import { setUserCartList } from '../redux/userCart';
import { initUserInfo } from '../redux/userInfo';
import { getSearchPreviewList } from '../api/services/productService';
import { getMenuList } from '../api/services/systemService';

const HeaderWrapper = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3% 0 2% 0;
  background: white;
  height: 40px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 40px 20px 20px 20px;
    gap: 15px;
    position: relative;
    height: auto;
  }

  @media (max-width: 480px) {
    padding: 20px 15px 15px 15px;
    gap: 10px;
    height: auto;
  }
`;

const Logo = styled.a`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;

  img {
    height: 80px;
  }

  @media (max-width: 768px) {
    position: relative;
    left: auto;
    transform: none;
    justify-content: center;
    width: 100%;
    order: 2;

    img {
      height: 50px;
    }
  }

  @media (max-width: 480px) {
    img {
      height: 40px;
    }
  }
`;

const SearchContainer = styled.div`
  position: absolute;
  left: 5%;
  width: 25%;

  @media (max-width: 768px) {
    position: relative;
    left: auto;
    width: 100%;
    order: 3;
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

const SearchBar = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  border-radius: 10px;
  align-items: center;
  border: 2px solid #c19330;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: 45px;
  }

  @media (max-width: 480px) {
    height: 40px;
  }
`;

const SearchButton = styled.button`
  background-color: #c19330;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 50px;
  height: 50px;
  border: none;
  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    width: 45px;
    height: 45px;
  }

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
  }
`;

const PreviewList = styled.ul`
  position: absolute;
  top: 55px;
  width: 95%;
  max-height: 220px;
  background-color: #fff;
  border: 1px solid ${(props) => props.theme.colors.primaryBlue};
  border-radius: 10px;
  overflow-y: auto;
  z-index: 10;
  list-style: none;
  padding: 8px 0;
  margin: 0;

  @media (max-width: 768px) {
    top: 50px;
    width: 100%;
    max-height: 200px;
  }

  @media (max-width: 480px) {
    top: 45px;
    max-height: 180px;
  }
`;

const PreviewItem = styled.li`
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors.subBackground};
  }

  @media (max-width: 480px) {
    padding: 8px 12px;
  }
`;

const PreviewContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

const PreviewImage = styled.img`
  display: flex;
  width: 60px;
  height: 60px;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.subBackground};

  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
  }
`;

const PreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 480px) {
    gap: 5px;
  }
`;

const PreviewContentText = styled.div`
  display: flex;
  font-size: 12px;

  @media (max-width: 480px) {
    font-size: 11px;
  }
`;

const HeaderMenuContainer = styled.div`
  display: flex;
  position: absolute;
  right: 5%;
  align-items: baseline;

  @media (max-width: 768px) {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    width: auto;
    justify-content: flex-start;
    order: 1;
    flex-wrap: wrap;
    gap: 10px;
  }

  @media (max-width: 480px) {
    gap: 5px;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  color: ${(props) => props.theme.colors.menuText};
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: color 0.2s ease;

  &:hover {
    color: ${(props) => props.theme.colors.primaryBlue};
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileMenuCloseButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 28px;
  color: ${(props) => props.theme.colors.menuText};
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: color 0.2s ease;
  position: absolute;
  left: 20px;
  top: 30px;
  z-index: 10;
  align-items: center;
  justify-content: center;
  gap: 5px;
  flex-direction: row;

  &:hover {
    color: ${(props) => props.theme.colors.primaryBlue};
  }

  @media (max-width: 768px) {
    display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  }

  @media (max-width: 480px) {
    left: 15px;
    top: 25px;
    font-size: 24px;
    gap: 4px;
  }
`;

const MenuCloseText = styled.span`
  font-size: 16px;
  font-weight: 500;

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const MobileMenu = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  padding: 20px;
  flex-direction: column;
  gap: 15px;

  @media (max-width: 768px) {
    display: ${(props) => (props.isOpen ? 'grid' : 'none')};
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    padding: 20px;
  }

  @media (max-width: 480px) {
    gap: 12px;
    padding: 15px;
  }
`;

const MobileMenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  background: none;
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  color: ${(props) => props.theme.colors.menuText};
  border-bottom: 1px solid ${(props) => props.theme.colors.subBackground};

  &:hover {
    background: ${(props) => props.theme.colors.subBackground};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 15px;
    border: 1px solid ${(props) => props.theme.colors.subBackground};
    border-radius: 8px;
    border-bottom: 1px solid ${(props) => props.theme.colors.subBackground};
    background: ${(props) => props.theme.colors.subBackground || '#f5f5f5'};
    transition: all 0.2s ease;
    min-height: 80px;
    gap: 8px;
    font-size: 12px;

    &:hover {
      background: ${(props) => props.theme.colors.primaryBlue || '#2b83bf'};
      color: white;
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    svg {
      font-size: 24px;
    }
  }

  @media (max-width: 480px) {
    padding: 15px 10px;
    min-height: 70px;
    font-size: 11px;
    gap: 6px;

    svg {
      font-size: 20px;
    }
  }
`;

const MobileMenuListContainer = styled.div`
  display: none;
  flex-direction: column;
  width: 100%;
  margin-top: 0;
  padding: 0;
  border-top: 1px solid
    ${(props) => props.theme.colors.subBackground || '#e0e0e0'};

  @media (max-width: 768px) {
    display: flex;
    grid-column: 1 / -1;
    width: 100%;
    margin-left: -20px;
    margin-right: -20px;
    padding: 0;
    width: calc(100% + 40px);
    margin-top: 0;
  }

  @media (max-width: 480px) {
    margin-left: -15px;
    margin-right: -15px;
    width: calc(100% + 30px);
  }
`;

const MobileMenuListItem = styled.button`
  display: flex;wha
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  padding: 12px 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: ${(props) => (props.isMain ? 'bold' : 'normal')};
  color: ${(props) => props.theme.colors.menuText || '#333'};
  text-align: left;
  border-bottom: 1px solid
    ${(props) => props.theme.colors.subBackground || '#e0e0e0'};
  transition: background-color 0.2s ease;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    background-color: ${(props) =>
      props.theme.colors.subBackground || '#f5f5f5'};
  }

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 480px) {
    padding: 10px 15px;
    font-size: 13px;
  }
`;

const MobileMenuSubItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  padding: 10px 20px 10px 30px;
  cursor: pointer;
  font-size: 13px;
  font-weight: normal;
  color: ${(props) => props.theme.colors.menuText || '#333'};
  text-align: left;
  border-bottom: 1px solid
    ${(props) => props.theme.colors.subBackground || '#e0e0e0'};
  transition: background-color 0.2s ease;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    background-color: ${(props) =>
      props.theme.colors.subBackground || '#f5f5f5'};
  }

  @media (max-width: 480px) {
    padding: 8px 15px 8px 25px;
    font-size: 12px;
  }
`;

const MenuArrow = styled.button`
  font-size: 14px;
  color: ${(props) => props.theme.colors.menuText || '#666'};
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;

  ${(props) =>
    props.isExpanded &&
    `
    transform: rotate(90deg);
  `}

  &:hover {
    color: ${(props) => props.theme.colors.primaryBlue || '#2b83bf'};
  }
`;

const CategoriesHeader = styled.h3`
  display: none;
  font-size: 16px;
  font-weight: bold;
  color: ${(props) => props.theme.colors.menuText || '#333'};
  margin: 0;
  padding: 15px 20px 0 20px;

  @media (max-width: 768px) {
    display: block;
    grid-column: 1 / -1;
    margin-left: -20px;
    margin-right: -20px;
    padding: 15px 20px 0 20px;
    width: calc(100% + 40px);
  }

  @media (max-width: 480px) {
    margin-left: -15px;
    margin-right: -15px;
    padding: 12px 15px 0 15px;
    font-size: 15px;
    width: calc(100% + 30px);
  }
`;

const AccountDropdown = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 70px;
  left: 0;
  width: 200px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  gap: 16px;
  padding: 10px 0;
  z-index: 999;

  @media (max-width: 768px) {
    position: static;
    width: 100%;
    box-shadow: none;
    border: 1px solid ${(props) => props.theme.colors.subBackground};
    border-radius: 5px;
    margin-top: 10px;
  }
`;

const AccountButton = styled.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  gap: 10px;
  cursor: pointer;
  &:hover {
    background: ${(props) => props.theme.colors.subBackground};
  }

  @media (max-width: 768px) {
    padding: 12px 15px;
    font-size: 14px;
  }
`;

const CartDropdown = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 60px;
  right: 0;
  width: 420px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  gap: 16px;
  z-index: 999;

  @media (max-width: 768px) {
    position: static;
    width: 100%;
    box-shadow: none;
    border: 1px solid ${(props) => props.theme.colors.subBackground};
    border-radius: 5px;
    margin-top: 10px;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const CartItemInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0 10px 10px;
  gap: 10px;

  @media (max-width: 768px) {
    padding: 10px;
    gap: 8px;
  }
`;

const CartItem = styled.div`
  display: flex;
  flex-direction: row;
  width: 90%;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.subBackground};
  }
`;

const Row = styled.div`
  display: flex;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    align-items: flex-end;
  }
`;

const CartItemImage = styled.img`
  display: flex;
  width: 60px;
  height: 60px;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.subBackground};

  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
  }
`;

const CartItemInfo = styled.div`
  margin-left: 10px;
  padding-top: 5px;
  max-width: 200px;
  display: flex;
  flex-direction: row;
  gap: 4px;

  @media (max-width: 768px) {
    margin-left: 0;
    max-width: none;
    flex: 1;
  }
`;

const CartSummary = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  justify-content: space-between;
  background: ${(props) => props.theme.colors.subBackground};

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const TotalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
`;

const PriceText = styled.p`
  font-weight: 700;
  font-size: 1.5rem;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const RemoveButton = styled.button`
  margin-left: 20px;
  width: 25px;
  height: 25px;
  display: flex;
  align-self: flex-start;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.subBackground};
  border: none;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const CartButton = styled.button`
  width: 90%;
  padding: 12px;
  margin-bottom: 10px;
  background: ${(props) => props.theme.colors.primaryBlue};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  align-self: center;
  &:hover {
    opacity: 0.7;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 0;
  }
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  font-size: 14px;
  color: ${(props) => props.theme.colors.menuText};
  text-align: center;
  margin-left: 15px;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  transition: color 0.2s ease;

  svg {
    font-size: 18px;
  }

  &:hover {
    color: ${(props) => props.theme.colors.primaryBlue};
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const Header = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo);
  const userCart = useSelector((state) => state.userCart);

  const theme = useTheme();
  const navigate = useNavigate();

  const [keyword, setKeyword] = useState('');
  const [searchPreviewList, setSearchPreviewList] = useState([]);
  const [showAccount, setShowAccount] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [menuList, setMenuList] = useState([]);
  const [expandedMenus, setExpandedMenus] = useState(new Set());

  useEffect(() => {
    if (userInfo.userId != 0) {
      getDbCartList();
    }
    getDbMenuList();
  }, [userInfo]);

  useEffect(() => {
    const totPrice = userCart.cart_list.reduce(
      (sum, item) => sum + item.price * item.totQty,
      0,
    );
    setTotalPrice(totPrice);
  }, [userCart]);

  useEffect(() => {
    if (userInfo.userId == 0) {
      setSearchPreviewList([]);
      return;
    }

    if (keyword.length > 1) {
      getDbSearchPreviewList();
    } else {
      setSearchPreviewList([]);
    }
  }, [keyword, userInfo.userId]);

  const brandNames = [
    'tiger',
    'zojirushi',
    'cuchen',
    'panasonic',
    'salux',
    'joycook',
    'joylife',
    //'hario',
    'benriner',
    'glasslock',
    'cleanwrap',
    'edison chopsticks',
    'nature republic',
    //'bigen',
    'salonpas',
    'via',
  ];

  const capitalizeBrandName = (brandName) => {
    return brandName
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const getSearchType = (input) => {
    const trimmed = input.trim();
    const lowerCased = trimmed.toLowerCase();

    // Check if it's a brand name (case-insensitive)
    if (brandNames.includes(lowerCased)) {
      return 'brand';
    }

    // Check if it's a barcode (8-14 digits only, no letters)
    if (/^\d{8,14}$/.test(trimmed)) {
      return 'barcode';
    }

    // Check if it's a SKU - must contain letters, numbers, AND a separator (-, _, or .)
    // This prevents natural searches like "10cup", "4cup" from being detected as SKUs
    // Only explicit SKU formats like "SKU-123", "PROD_456", "ITEM.789" are detected
    const hasLetters = /[A-Z]/i.test(trimmed);
    const hasNumbers = /\d/.test(trimmed);
    const hasSeparator = /[-._]/.test(trimmed);
    const isValidFormat = /^[A-Z0-9._-]{3,20}$/i.test(trimmed);

    if (isValidFormat && hasLetters && hasNumbers && hasSeparator) {
      return 'sku';
    }

    // Everything else is a keyword search (default priority)
    // This includes: "bowl", "spoon", "10cup", "4cup", "rice cooker", etc.
    return 'keyword';
  };

  const getDbSearchPreviewList = async () => {
    try {
      // Always use flexible keyword search for preview dropdown
      // This ensures partial matches work for all input types (keywords, SKUs, barcodes)
      const params = {
        keyword: keyword,
        idCustomer: userInfo.idCustomer,
        brandId: userInfo.brandId,
        priceLev: '01',
      };
      const result = await getSearchPreviewList(
        params.keyword,
        params.idCustomer,
        params.brandId,
        params.priceLev,
      );
      setSearchPreviewList(result.searchList || []);
    } catch (error) {
      setSearchPreviewList([]);
    }
  };

  const getDbCartList = async () => {
    if (userInfo.zipcode) {
      const result = await getCartList(
        userInfo.idCustomer,
        userInfo.zipcode,
        userInfo.idStore,
      );
      const totPrice = result.cartList.reduce(
        (sum, item) => sum + item.price * item.totQty,
        0,
      );
      setTotalPrice(totPrice);
      dispatch(setUserCartList({ cart_list: result.cartList }));
    }
  };

  const getDbMenuList = async () => {
    try {
      const result = await getMenuList();
      const categoryMap = {};
      const menuList = [];

      // Build category map
      result.menuList.forEach((cat) => {
        categoryMap[cat.idWebCate] = {
          id: cat.idWebCate,
          title: cat.cateNm,
          link: `/search?category=${encodeURIComponent(cat.cateNm.toLowerCase())}`,
          level: cat.level,
          parentId: cat.pCode,
          cateNm: cat.cateNm,
          subMenu: {
            type: 'singleColumn',
            items: [],
          },
        };
      });

      // Build hierarchical URL key for each menu item
      const buildUrlKey = (menuItem) => {
        const pathNames = [];
        let current = menuItem;

        while (current) {
          const urlPart = current.cateNm
            .toLowerCase()
            .replace(/[^a-z\s]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
          pathNames.unshift(urlPart);
          current = categoryMap[current.parentId];
        }

        return pathNames.join('-');
      };

      // Update all links with hierarchical URL keys
      Object.values(categoryMap).forEach((menuItem) => {
        const urlKey = buildUrlKey(menuItem);
        menuItem.link = `/search?category=${encodeURIComponent(urlKey)}`;
      });

      // Build menu hierarchy
      result.menuList.forEach((cat) => {
        if (cat.level === 1) {
          menuList.push(categoryMap[cat.idWebCate]);
        } else if (categoryMap[cat.pCode]) {
          categoryMap[cat.pCode].subMenu.items.push(categoryMap[cat.idWebCate]);
        }
      });

      // Clean up empty subMenus
      const clean = (menu) => {
        if (menu.subMenu.items.length === 0) {
          delete menu.subMenu;
        } else {
          menu.subMenu.items.forEach(clean);
        }
      };
      menuList.forEach(clean);

      setMenuList(menuList);
    } catch (error) {
      setMenuList([]);
    }
  };

  const onClickAccount = () => {
    if (userInfo.userId != 0) {
      navigate('/myaccount/orders');
    } else {
      navigate('/login');
    }
    setIsMobileMenuOpen(false);
  };

  const onClickCart = () => {
    navigate('/cart');
    setIsMobileMenuOpen(false);
  };

  const onClickRemove = async (item) => {
    const result = await removeCart(userInfo.idCustomer, item.idCartDtl);
    if (result.is_success) {
      getDbCartList();
      alert(`${item.webTitle} remove from cart!`);
    } else {
      alert(`Error while add to cart`);
    }
  };

  const onClickMyAccount = () => {
    if (userInfo.userId != 0) {
      navigate('/myaccount/customer');
    } else {
      navigate('/login');
    }
    setIsMobileMenuOpen(false);
  };

  const onClickWebOrderHistory = () => {
    if (userInfo.userId != 0) {
      navigate('/myaccount/orders');
    } else {
      navigate('/login');
    }
    setIsMobileMenuOpen(false);
  };

  const onClickLogout = () => {
    localStorage.removeItem('token');
    dispatch(initUserInfo());
    navigate('/');
    window.location.reload();
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const renderAccountView = () => {
    if (userInfo.userId != 0) {
      return (
        <AccountDropdown
          onMouseEnter={() => setShowAccount(true)}
          onMouseLeave={() => setShowAccount(false)}
        >
          <AccountButton onClick={onClickWebOrderHistory}>
            <FaShoppingCart size={'16px'} />
            <BodyText>Web Orders History</BodyText>
          </AccountButton>
          <AccountButton onClick={onClickLogout}>
            <CiLogout size={'18px'} />
            <BodyText>Log out</BodyText>
          </AccountButton>
        </AccountDropdown>
      );
    }
  };

  const handleSearch = () => {
    if (userInfo.userId != 0) {
      const searchKeyword = keyword.trim();
      if (searchKeyword) {
        const searchType = getSearchType(searchKeyword);

        if (searchType === 'brand') {
          // Search by brand - capitalize the brand name
          const capitalizedBrand = capitalizeBrandName(searchKeyword);
          window.location.hash = `#/search?brand=${encodeURIComponent(capitalizedBrand)}&page=1`;
        } else if (searchType === 'barcode') {
          // Search by barcode
          window.location.hash = `#/search?barcode=${encodeURIComponent(searchKeyword)}&page=1`;
        } else if (searchType === 'sku') {
          // Search by SKU
          window.location.hash = `#/search?sku=${encodeURIComponent(searchKeyword)}&page=1`;
        } else {
          // Regular keyword search
          window.location.hash = `#/search?keyword=${encodeURIComponent(searchKeyword)}&page=1`;
        }
        setKeyword('');
      }
    } else {
      navigate('/login');
    }
  };

  const renderCartView = () => {
    const totalItems = userCart.cart_list.reduce(
      (sum, item) => sum + item.totQty,
      0,
    );
    const totPrice = userCart.cart_list.reduce(
      (sum, item) => sum + item.price * item.totQty,
      0,
    );

    return (
      <CartDropdown
        onMouseEnter={() => setShowCart(true)}
        onMouseLeave={() => setShowCart(false)}
      >
        <CartItemInfoContainer>
          {userCart.cart_list.map((item, idx) => (
            <CartItem key={`cart_item_${idx}`}>
              <Row>
                <CartItemImage
                  src={`${process.env.REACT_APP_FILE_UPLOAD_URL}${item.filepath1}`}
                  alt={item.webTitle}
                />
                <CartItemInfo>
                  <BodyText>{item.webTitle}</BodyText>
                </CartItemInfo>
              </Row>
              <Row>
                <Column>
                  <BodyText
                    color={theme.colors.black}
                    weight={700}
                  >{`$${item.price.toFixed(2)}`}</BodyText>
                  <BodyText>{`Qty: ${item.totQty}`}</BodyText>
                </Column>
                <RemoveButton
                  onClick={() => {
                    onClickRemove(item);
                  }}
                >
                  <IoCloseOutline size={20} />
                </RemoveButton>
              </Row>
            </CartItem>
          ))}
        </CartItemInfoContainer>

        <CartSummary>
          <TotalContainer>
            <BodyText>
              <FaShoppingCart style={{ marginRight: '5px' }} />
              {`${totalItems} item(s)`}
            </BodyText>
            <Row style={{ alignItems: 'center', gap: '10px' }}>
              <BodyText>Total:</BodyText>
              <PriceText>{`$${totPrice.toFixed(2)}`}</PriceText>
            </Row>
          </TotalContainer>
          <CartButton
            onClick={() => {
              onClickCart();
            }}
          >
            GO TO CART
          </CartButton>
        </CartSummary>
      </CartDropdown>
    );
  };

  const renderSearchPreview = (preview) => {
    // Handle both preview format (Tfilepath1) and product format (filepath1)
    const imagePath = preview.Tfilepath1 || preview.filepath1 || '';

    return (
      <PreviewItem
        onClick={() => {
          setKeyword('');
          if (userInfo.userId != 0) {
            navigate(`/product?id=${preview.idStyle}`);
          } else {
            navigate('/login');
          }
        }}
      >
        <PreviewContainer>
          <PreviewImage
            src={`${process.env.REACT_APP_FILE_UPLOAD_URL}${imagePath}`}
          />
          <PreviewContent>
            {preview.idStyle && (
              <PreviewContentText>{`sku : ${preview.idStyle}`}</PreviewContentText>
            )}
            <PreviewContentText>
              {preview.websitename || preview.webTitle}
            </PreviewContentText>
          </PreviewContent>
        </PreviewContainer>
      </PreviewItem>
    );
  };

  const renderMobileMenu = () => {
    return (
      <MobileMenu isOpen={isMobileMenuOpen}>
        <MobileMenuItem onClick={onClickAccount}>
          <FaUser />
          {userInfo.userId != 0
            ? `${userInfo.companyNm} - ${userInfo.firstname}`
            : 'Welcome'}
        </MobileMenuItem>
        {userInfo.userId != 0 && (
          <MobileMenuItem onClick={onClickLogout}>
            <CiLogout />
            Logout
          </MobileMenuItem>
        )}

        <MobileMenuItem onClick={() => navigate('/favorites')}>
          <FaHeart />
          Favorites
        </MobileMenuItem>
        {userInfo.userId != 0 && (
          <MobileMenuItem onClick={onClickCart}>
            <FaShoppingCart />
            Cart ({userCart.cart_list.length} items)
          </MobileMenuItem>
        )}

        <CategoriesHeader>Categories</CategoriesHeader>
        <MobileMenuListContainer>
          {menuList.map((menu) => {
            const isExpanded = expandedMenus.has(menu.id);
            return (
              <div key={menu.id}>
                <MobileMenuListItem
                  isMain={true}
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    if (userInfo.userId != 0) {
                      navigate(menu.link);
                    } else {
                      navigate('/login');
                    }
                  }}
                >
                  <span>{menu.title}</span>
                  {menu.subMenu && menu.subMenu.items.length > 0 && (
                    <MenuArrow
                      isExpanded={isExpanded}
                      onClick={(e) => {
                        e.stopPropagation();
                        const newExpanded = new Set(expandedMenus);
                        if (isExpanded) {
                          newExpanded.delete(menu.id);
                        } else {
                          newExpanded.add(menu.id);
                        }
                        setExpandedMenus(newExpanded);
                      }}
                    >
                      &#10095;
                    </MenuArrow>
                  )}
                </MobileMenuListItem>
                {isExpanded &&
                  menu.subMenu &&
                  menu.subMenu.items.map((subMenu) => {
                    const isSubExpanded = expandedMenus.has(subMenu.id);
                    return (
                      <div key={subMenu.id}>
                        <MobileMenuSubItem
                          onClick={() => {
                            setIsMobileMenuOpen(false);
                            if (userInfo.userId != 0) {
                              navigate(subMenu.link);
                            } else {
                              navigate('/login');
                            }
                          }}
                        >
                          <span>{subMenu.title}</span>
                          {subMenu.subMenu &&
                            subMenu.subMenu.items.length > 0 && (
                              <MenuArrow
                                isExpanded={isSubExpanded}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const newExpanded = new Set(expandedMenus);
                                  if (isSubExpanded) {
                                    newExpanded.delete(subMenu.id);
                                  } else {
                                    newExpanded.add(subMenu.id);
                                  }
                                  setExpandedMenus(newExpanded);
                                }}
                              >
                                &#10095;
                              </MenuArrow>
                            )}
                        </MobileMenuSubItem>
                        {isSubExpanded &&
                          subMenu.subMenu &&
                          subMenu.subMenu.items.map((subSubMenu) => (
                            <MobileMenuSubItem
                              key={subSubMenu.id}
                              style={{ paddingLeft: '45px' }}
                              onClick={() => {
                                setIsMobileMenuOpen(false);
                                if (userInfo.userId != 0) {
                                  navigate(subSubMenu.link);
                                } else {
                                  navigate('/login');
                                }
                              }}
                            >
                              <span>{subSubMenu.title}</span>
                            </MobileMenuSubItem>
                          ))}
                      </div>
                    );
                  })}
              </div>
            );
          })}
          <MobileMenuListItem
            isMain={true}
            onClick={() => {
              setIsMobileMenuOpen(false);
              navigate('/brands');
            }}
          >
            <span>Shop By Brand</span>
          </MobileMenuListItem>
        </MobileMenuListContainer>
      </MobileMenu>
    );
  };

  return (
    <HeaderWrapper onMouseLeave={() => setShowCart(false)}>
      <MobileMenuCloseButton
        isOpen={isMobileMenuOpen}
        onClick={toggleMobileMenu}
      >
        <IoCloseOutline />
        <MenuCloseText>Menu</MenuCloseText>
      </MobileMenuCloseButton>
      <Logo as={Link} to={'/'}>
        <img src={logo} alt='Eden Marketing Corp.' />
      </Logo>

      <SearchContainer>
        <MobileMenuButton onClick={toggleMobileMenu}>
          <FaBars />
        </MobileMenuButton>
        <SearchBar>
          <Input
            placeholder='Search'
            value={keyword}
            onChange={(e) => {
              setKeyword(e);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <SearchButton onClick={handleSearch}>
            <FaSearch />
          </SearchButton>
          {keyword.length > 1 && searchPreviewList.length > 0 ? (
            <PreviewList>
              {searchPreviewList.map((preview) => {
                return renderSearchPreview(preview);
              })}
            </PreviewList>
          ) : null}
        </SearchBar>
      </SearchContainer>

      <HeaderMenuContainer>
        <MenuButton
          onMouseEnter={() => {
            setShowCart(false);
            setShowAccount(true);
          }}
          onClick={onClickAccount}
        >
          <FaUser />
          {userInfo.userId != 0
            ? `${userInfo.companyNm} | ${userInfo.firstname}`
            : 'Welcome'}
        </MenuButton>
        <MenuButton
          onMouseEnter={() => {
            setShowCart(false);
            setShowAccount(false);
          }}
          onClick={() => navigate('/favorites')}
        >
          <FaHeart /> Favorites
        </MenuButton>
        {userInfo.userId != 0 ? (
          <MenuButton
            onClick={onClickCart}
            onMouseEnter={() => {
              setShowCart(true);
              setShowAccount(false);
            }}
          >
            <FaShoppingCart /> <>{`${userCart.cart_list.length} items`}</>
          </MenuButton>
        ) : null}
        {showAccount ? renderAccountView() : null}
        {showCart ? renderCartView() : null}
      </HeaderMenuContainer>

      {renderMobileMenu()}
    </HeaderWrapper>
  );
};

export default Header;
